<template>
  <div id="content" class="candidate_pool_main">
      <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>
      <AddPool :dialogVisible='dialogNewPool' @close="closeModalPool()" @newValueIsProposed="setNewPool($event)" formName="Specify the startups you are interested in (leave blank otherwise)" ></AddPool>

    <div class="container" v-if="candidatespool.length > 0">
      <div class="all_candidates_download_zone " v-if="scouting_challenge.fullCandidatesList">
        <div class="col-12 text-center">
          <span class="title">ALL POTENTIAL CANDIDATES</span>
          <span class="description"></span>
          <a :href="this.apiUrl+'/get_image/'+scouting_challenge.fullCandidatesList.$oid+'?token='+$store.state.innotoken" type="button" name="button" target="_blank" class="next_step_btn">
            <img :src="require('@/assets/greyDownload.svg')" alt="" class="left goFullWhite">
            DOWNLOAD FULL LIST
          </a>
        </div>
      </div>

      <div class="candidate_pool">
        <div class="onePool"  v-for="(pool, p) in candidatespool" :key="p">


        <div class="col-12 text-center">
          <span class="pool_title">Candidate pool {{p + 1}}</span>
          <span class="pool_subtitle">Top candidates from our analysis</span>
        </div>
        <div class="row mt50" v-if="pool.inProgress != true">
            <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in pool.candidates" :key="c">
              <div class="candidate_card">

                <router-link :to="'/startup/'+candidate._id.$oid+'/'+project._id.$oid"  v-if="candidate._id">
                  <img :src="this.apiUrl+'/get_image/'+candidate.image.$oid+'?token='+$store.state.innotoken" class="candidate_image" alt="" v-if="candidate.image">
                  <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="candidate_image" alt="" v-else>
                  </router-link>
              <div class="candidate_info_content">
                        <router-link :to="'/startup/'+candidate._id.$oid+'/'+project._id.$oid"  v-if="candidate._id">    <span class="candidate_name">{{candidate.name}}</span>  </router-link>
                <span class="candidate_desc">{{candidate.short_desc}}</span>
              </div>
              <div class="row candidate_links">
                <div class="details">
                    <router-link :to="'/startup/'+candidate._id.$oid+'/'+project._id.$oid"  v-if="candidate._id"><img :src="require('@/assets/eye.svg')" alt="" class="left">
                    Details
                    </router-link>
                </div>
                <div class="selectIt" v-if="project.challenges.assessment_challenge == true">
                  <label><span>Select for assessment </span><input type="checkbox" v-model="candidate.isSelected" :disabled="selection_done"></label>
                </div>
              </div>
              <div class="candidate_links candidate_comments" style="">
                <div >


                <small>Comment<span v-if="candidate.comments.length > 1">s</span></small>
                <div class="comments_list">
                    <div class="one_comment" v-for="(comment, i) in candidate.comments" :key="i">
                      <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                          <span v-else>{{comment}}</span>
                    </div>

                </div>
                    </div>
                <div class="add_comment col-12 text-right">
                    <button type="button" class="add_new_comment" @click='openModal(candidate)' name="button">
                      <img :src="require('@/assets/comments.svg')" alt="">
                      Add a comment</button>
                </div>
              </div>
                    </div>
            </div>
        </div>
                <div class="row mt50" v-else>
                  <div class="alert alert-warning">

                    <p v-if="pool.comments">  A new candidate pool is in development, with the following instructions: <span v-html="pool.comments"></span></p>
                    <p v-else>  A new candidate pool is in development.</p>
                  </div>
                </div>
        </div>

         <div class="askNewPool col-12 text-center"  v-if="project.challenges.scouting_challenge == true && !selection_done && selectedCandidates.length < 9 && canAssess">

          <button type="button" name="button" class="prev_step_btn" @click="openModalPool()">
            <img :src="require('@/assets/plusbleu.svg')" alt="" class=" ">
            ADD A NEW POOL
          </button>
        </div>
        <!-- <div class="askNewPool col-12 text-center" >

          <button type="button" name="button" class="prev_step_btn" @click="openModalPool()">
            <img :src="require('@/assets/plusbleu.svg')" alt="" class=" ">
            ADD A NEW POOL
          </button>
        </div> -->

        <div class="selection" v-if="project.challenges.assessment_challenge == true">
          <span class="title">YOUR SELECTION FOR ASSESSMENT</span>
          <div class="candidateSelection">
            <div class="selectedOne" v-for="(selected,p) in selectedCandidates" :key="p">
                <img :src="this.apiUrl+'/get_image/'+selected.image.$oid+'?token='+$store.state.innotoken"  alt="" v-if="selected.image">
                <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="" alt="" v-else>

                <span>{{selected.name}}</span>
            </div>
          </div>
          <div class="col-12 text-center mt50" v-if="selection_done != true">
            <button type="button" name="button" class="next_step_btn" @click='saveSelection()'>
            SAVE
            </button>
            <button type="button" name="button" class="next_step_btn" @click='submitSelection()' v-if="project.challenges.assessment_challenge == true && canAssess">
              LAUNCH ASSESSMENT
              <img :src="require('@/assets/next.svg')" alt="">
            </button>

          </div>
          <div class="col-12 text-center mt50" v-if="selection_done == true">
            <router-link type="button" name="button" class="prev_step_btn" :to='"/projet/"+project._id.$oid'>
              <img :src="require('@/assets/prev.svg')" alt="">
              BACK TO DASHBOARD

            </router-link>
          </div>
        </div>
        <div class="col-12 text-center mt50" v-else>

          <router-link type="button" name="button" class="prev_step_btn" :to='"/projet/"+project._id.$oid'>
            <img :src="require('@/assets/prev.svg')" alt="">
            BACK TO DASHBOARD

          </router-link>
          <button type="button" name="button" class="next_step_btn" @click='closeScouting()' v-if="project.challenges.assessment_challenge != true && !selection_done">
            CLOSE SCOUTING
            <img :src="require('@/assets/next.svg')" alt="">
          </button>
        </div>
      </div>
    </div>

     <!-- <div class="container" v-if="project.challenges && ( (!scouting_challenge || selection_done != true))"> -->
     <div class="container">
      <div class="all_candidates_download_zone ">
        <div class="col-12 text-center">
          <span class="title">YOUR OWN CANDIDATES</span>
          <div class="row mt20">
              <span class="pool_subtitle mb10">Step 1</span><br/>
            <a href="/doc/Your-Startup-Selection.xlsx" target="_blank" download>Download and complete our template file</a>

          </div>
          <div class="row mt20">
            <span class="pool_subtitle mb10">Step 2</span>
            <FileUploaderStartup :search_field="this.$route.params.search_field_id" fileType="business_challenge_brief" @fileUploaded="fileIsUpload"/>
          </div>
          <!-- <label type="button" name="button" class="next_step_btn" >
            <input
                    ref="image"
                    type="file"
                    style="display: none"
                    @change="uploadPool"
                    multiple
                  />
            <img :src="require('@/assets/greyDownload.svg')" alt="" class="left goFullWhite">
            UPLOAD YOUR CANDIDATE SELECTION
          </label> -->


        </div>
      </div>
    </div>

  </div>
</template>
<script>
import exportFromJSON from "export-from-json";
import { toast } from 'vue-sonner'
import api from '../tools/api';
import CSVFileValidator from 'csv-file-validator'
 import AddCommentModal from '@/components/modals/addComment.vue'
import FileUploaderStartup from '@/components/FileUploaderStartup.vue';
 import AddPool from '@/components/modals/addPool.vue'

export default {
  components: {
    AddCommentModal,
    FileUploaderStartup,
    AddPool
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      dialog: false,
      dialogNewPool: false,
      pageInfo: {
        mainTitle : "Scouting space",
        subTitle : "View and validate your preferred candidates",
      },
      scouting_challenge : {
        isSubmit : false
      },
      candidateForComments : null,
      project: {},
      candidatespool: [],
      // candidatespool: [
      //   {
      //     id:"Pool 1",
      //     candidates: [
      //       {
      //         id:"6492de3ab9dc92db3b3129bb",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg",
      //         name:"Choix 1.1",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: false
      //       },
      //       {
      //         id:"6492de3ab9dc92db3b3129bb",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-corporate.jpg",
      //         name:"Choix 1.2",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum. Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: true
      //       },
      //       {
      //         id:"6492de3ab9dc92db3b3129bb",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-startup.jpg",
      //         name:"Choix 1.3",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: false
      //       },
      //       {
      //         id:"6492de3ab9dc92db3b3129bb",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-dealmaking.jpg",
      //         name:"Choix 1.4",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: false
      //       },
      //     ]
      //   },
      //   {
      //     id:"Pool 2",
      //     candidates: [
      //       {
      //         id:"1",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg",
      //         name:"Choix 2.1",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: false
      //       },
      //       {
      //         id:"2",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-corporate.jpg",
      //         name:"Choix 2.2",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum. Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: true
      //       },
      //       {
      //         id:"3",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-startup.jpg",
      //         name:"Choix 2.3",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: false
      //       },
      //       {
      //         id:"4",
      //         img: "https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-dealmaking.jpg",
      //         name:"Choix 2.4",
      //         short_desc: "Sed ut accumsan enim Vitae dolor malesuada, elementum",
      //         selected: false
      //       },
      //     ]
      //   }
      //
      // ]
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    openModal(candidate){
      this.candidateForComments = candidate;
      this.dialog = true;
    },
    openModalPool(){
      this.dialogNewPool = true;
    },
    closeModal(){
      this.candidateForComments = "";
      this.dialog = false;
    },
    closeModalPool(){
      this.dialogNewPool = false;
    },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidate/add_comment",
        {
          comment : v,
          candidate : this.candidateForComments,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
          this.candidateForComments.comments.push(r.data);
          this.candidateForComments = null;
      }).catch( () => {
          this.candidateForComments = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      }

      this.dialog = false;
    },
    setNewPool(v){
      var top = {
        searchfield :this.$route.params.search_field_id ,
        comments : v
      };
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/add_pool_ask_by_customer",
          top,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);this.candidatespool.push(r.data);
          if(v){
              toast("We'll prepare a new candidate pool for you, taking into account these insights:  "+v);
          }
          else{
            toast("We'll prepare a new candidate pool for you. We'll get to  you shortly.");
          }
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      // if(v){
      //     toast("A new pool has been asked to our team. We will propose it soon. You provide the following information : "+v);
      // }
      // else{
      //   toast("A new pool has been asked to our team. We will propose it soon. You don't specify extra information about this new pool");
      // }
            this.dialogNewPool = false;
    },
    downloadAllCandidates(){
      var data = [];
      const fileName ="candidatespool";

     this.candidatespool.forEach((item,cpi) => {

       item.candidates.forEach((candidate) => {
         var tempo = {};
         tempo["Candidates pool"] = cpi+1;
         tempo["Candidate"] = candidate.name;
         tempo["Candidate description"] = candidate.short_desc;
         tempo["Candidate selection"] = candidate.isSelected;
         data.push(tempo);
       });

     });
     console.log(data);
      const exportType = exportFromJSON.types.csv;

      if (data) exportFromJSON({ data, fileName, exportType });
    },
    askForNewPool(){
      toast("A new pool has been asked to our team. We will propose it soon");
    },
    closeScouting(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidates_pool_close/"+this.$route.params.search_field_id,
          {
              value: this.candidatespool
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Your scouting challenge is finalized.");
          this.scouting_challenge.selectionIsSubmit = true;
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    submitSelection(){
      if(this.selectedCandidates.length < 1){
        toast.error("Please select at least one candidate for assessment.")
      }
      else if(this.selectedCandidates.length > 9){
        toast.error("You've selected too many candidates for assessment. Please include a maximum of 9 candidates. ")
      }
      else{
        console.log(this.candidatespool);
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidates_pool_submit/"+this.$route.params.search_field_id,
            {
                value: this.candidatespool
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("Your candidate selection is successfully submitted!");
            if(this.scouting_challenge == null)this.scouting_challenge = {};
            this.scouting_challenge.selectionIsSubmit = true;
          }).catch( () => {
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

    },

    saveSelection(){
      // toast.success("Candidate selection successfully submit ");
      // this.selection_done = true;
      // this.$store.commit('UPDATE_NOTIFICATION',1)
      console.log(this.candidatespool);
      api.post(process.env.VUE_APP_API_URL+"/search_field/candidates_pool/"+this.$route.params.search_field_id,
          {
              value: this.candidatespool
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("Your selection is saved.")
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    fileIsUpload(e){
      console.log(e);
      api.get(process.env.VUE_APP_API_URL+"/search_field/candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
        // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
        // console.log();
        // var temp = _.merge(this.candidatespool, r.data)
        console.log(r.data);
        this.scouting_challenge = r.data.scouting_challenge;
        this.project = r.data.project;
        //console.log(this.scouting_challenge);
        this.candidatespool = r.data.list_of_pools;
        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
       });
    },
    uploadPool(){
      console.log("POOL");
        var file = event.target.files.item(0);
        console.log(file);
        var config = {
          headers: [
            {
              name: "Name",
              inputName: "name",
              required: true,
            }
          ]
        }
        CSVFileValidator(file, config)
      .then(csvData => {
        console.log(csvData);
        if(csvData.inValidData.length > 0){
          toast.error("Oops, your file doesn't match our template. Please review and resubmit. Contact us in case of any questions. ")
        }
        else{
          toast.promise(() => new Promise((resolve,reject) => {
            api.post(process.env.VUE_APP_API_URL+"/upload_candidates/"+this.$route.params.search_field_id,csvData.data,{
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then( (r) => {
              console.log(r);
              resolve();

            }).catch( () => {
               reject(new Error("Error!"));
            });
          }), {
          loading: 'Proceed ',
          success: () => {
            //this.$store.commit('UPDATE_NOTIFICATION',1);
            api.get(process.env.VUE_APP_API_URL+"/search_field/candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
              // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
              // console.log();
              // var temp = _.merge(this.candidatespool, r.data)
              console.log(r.data);
              this.scouting_challenge = r.data.scouting_challenge;
              this.project = r.data.project;
              //console.log(this.scouting_challenge);
              this.candidatespool = r.data.list_of_pools;
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
            return 'Success'
          },
          error: (e) => {
            console.log(e);
            return "Error"
          }
        });
      }
      })
      .catch(() => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      })
    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)


     api.get(process.env.VUE_APP_API_URL+"/search_field/candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log("opqdfijuh");
       console.log(r.data);
       this.scouting_challenge = r.data.scouting_challenge;
       this.project = r.data.project;
       //console.log(this.scouting_challenge);
       this.candidatespool = r.data.list_of_pools;
       api.post(process.env.VUE_APP_API_URL+"/restrict/pools_unnew",{searchfield:this.$route.params.search_field_id},{
           headers: {
               'Content-Type': 'application/json',
           }
       })
       .then( (r) => {console.log(r);})
       .catch( () => {});

     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
 },
  computed:{
    selectedCandidates: function(){
      var selectedCandidatesTemp = [];
      this.candidatespool.forEach((pool) => {
        if(pool.candidates){
          pool.candidates.forEach((c) => {
              if(c.isSelected == true)selectedCandidatesTemp.push(c);
          });
        }


      });
      return selectedCandidatesTemp;
    },
    selection_done: function(){
      console.log(this.scouting_challenge);
      if(!this.scouting_challenge) return false;
      else if(this.scouting_challenge.selectionIsSubmit != true) return false
      else return true;
    },
    canAssess: function(){
      var can = true;
      this.candidatespool.forEach((pool) => {
        console.log(pool.inProgress);
        if(pool.inProgress){
          can = false;
          return false;
          //break;
        }

          // if(pool.inProgress == true){
          //   can = false;
          //   break;
          // }
      });
      return can;
    },
  }
}
</script>
<style scoped>
.candidate_pool_main{
  padding-top:50px;
  padding-bottom:50px;
}
.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

  .next_step_btn{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }
  .next_step_btn img.left{
    margin-right:10px;
  }
img.goFullWhite{
  filter: brightness(0) invert(1);
}
.candidate_pool{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
margin-top: 50px;
}

.pool_title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 1px solid #DDDDDD;
border-radius: 10px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.candidate_card .candidate_info_content{
  padding:20px;
  border-bottom: 1px solid #DDDDDD;
}

.candidate_card .candidate_links{
  padding:20px;
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:1;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
}
.mt50{
  margin-top: 50px;
}

.selection{
  margin-top:50px;
  border-top:1px solid #DDD;
  padding-top: 50px;

}
.selection .selectedOne{
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  width: calc(33% - 20px);
}
.selection .selectedOne img{
    width: 65px;
    height:65px;
    border-radius: 6px;
    object-fit: cover;
    margin-right: 10px;
}

.selection .candidateSelection{
  display:flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:50px;
}

@media screen and (max-width: 1200px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(50% - 20px);
  }
}
@media screen and (max-width: 990px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(100%);
  }
  .selection .candidateSelection{
    flex-direction: column;
  }
}

.onePool:not(:first-of-type){
  margin-top:50px;
}

.askNewPool button{
  font-size:12px;
  line-height: 15px;
}
.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}
.prev_step_btn img{
  margin-right:10px;
}
a{
  color:inherit;
}

.mt20{
  margin-top:20px;
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}

a{
  text-decoration: none;
}

.mb10{
  margin-bottom: 10px;
}
@media screen and (min-width:1301px) and (max-width:1650px){
  .candidate {
    flex: 0 0 auto;
    width: calc(100% / 3);
  }

}
@media screen and (min-width:1000px) and (max-width:1300px){
  .candidate {
    flex: 0 0 auto;
    width: 50%;
  }

}
</style>
